import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=4598ca25&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=4598ca25&prod&scoped=true&lang=css"
import style1 from "./notifications.vue?vue&type=style&index=1&id=4598ca25&prod&lang=css"
import style2 from "./notifications.vue?vue&type=style&index=2&id=4598ca25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598ca25",
  null
  
)

export default component.exports